//MyCertificatesThink5Whys.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../../hooks/useFetch';
import Loader from '../../../components/utils/Loader';
import Tooltip from '../../../components/utils/Tooltip';
import '../styles/MCQPractice.css';
import CertificateRenderer from './CertificateRenderer'; 

const MyCertificatesThink5Whys = () => {

    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const [userId, setUserId] = useState(authState.user._id);

    const [examSetList, setExamSetList] = useState([]);
    const [selectedExamSetId, setSelectedExamSetId] = useState('');    
    const [certificateData, setCertificateData] = useState(null);
    
    const fetchExamSetList = async () => {
        const config = {
            url: "/myexamsets/mysets",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userId: userId, isT5w: 1, setQuestionType: "MCQ" }
        };

        try {
            const response = await fetchData(config, { showSuccessToast: false });
            if (response && Array.isArray(response.examsetlist)) {
                setExamSetList(response.examsetlist);
            } else {
                console.error("Invalid response format: Exam set list not found in response");
            }
        } catch (error) {
            console.error("Error fetching exam list:", error);
        }
    };

    useEffect(() => {
        fetchExamSetList();
    }, []);

    const handleExamSetView = (setId) => {
        setSelectedExamSetId(prevId => (prevId === setId ? null : setId));
    };

    function convertTimeLimit(minutes) {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const formattedTimeLimit = `${hours}:${remainingMinutes} (Hr:Min)`;
        return formattedTimeLimit;
    }

    function convertTimeTaken(milliseconds) {
        const hours = Math.floor(milliseconds / 3600000);
        const remainingMinutes = Math.floor((milliseconds % 3600000) / 60000);
        const remainingSeconds = Math.floor((milliseconds % 60000) / 1000);
        const remainingMilliseconds = milliseconds % 1000;
        const formattedTime = `${hours}:${remainingMinutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}.${remainingMilliseconds.toString().padStart(3, "0")} (Hr:Min:Sec)`;
        return formattedTime;
    }

    const handleCertificateView = (certificateNumber, certificateDate, certificateName, certificateTitle, certificateRemarks, certificateTemplate, signImage1, signName1, signDesig1, signEntity1, isSignatory2, signImage2, signName2, signDesig2, signEntity2, hasSponsor, sponsorName, sponsorLogo) => {
        setCertificateData({ certificateNumber, certificateDate, certificateName, certificateTitle, certificateRemarks, certificateTemplate, signImage1, signName1, signDesig1, signEntity1, isSignatory2, signImage2, signName2, signDesig2, signEntity2, hasSponsor, sponsorName, sponsorLogo });
    };

    return (
        <div className="min-h-screen bg-black py-2 [&_p]:text-white">
            <div className='border-b border-blue-400 mb-2'>
                <h2 className="text-m lg:text-lg font-extrabold text-center text-yellow-200 p-2">
                    📖 My Think5Whys Certificates
                </h2>
            </div>
            <div className="min-h-[85vh] w-full px-4">
                <div className="bg-black text-white rounded-lg shadow-lg p-4 mt-4">
                    {loading ? (
                        <div className="flex justify-center items-center py-8">
                            <Loader />
                        </div>
                    ) : (
                        <div className='mb-4'>
                        {/* <h3 className="text-xl font-bold text-yellow-200 mb-4">My Think5Whys Certificates</h3> */}

                        {examSetList && examSetList.length === 0 ? (
                            <div className="w-full h-64 flex items-center justify-center text-yellow-300">
                                No records found!
                            </div>
                        ) : (
                            examSetList.map((examSet, index) => (
                            <div
                                key={examSet._id}
                                className="bg-black border border-gray-100 my-4 p-4 rounded-lg shadow-sm "
                            >
                                <div className="flex items-center justify-between">
                                <p className="font-medium text-white">
                                    {index + 1}. {examSet.examTitle}, Date: {new Date(examSet.dateExam).toLocaleDateString()}
                                </p>
                                <div className="flex space-x-2">
                                    <Tooltip text="View details" position="top">
                                    <span
                                        className="text-blue-500 cursor-pointer hover:text-blue-700 transition"
                                        onClick={() => handleExamSetView(examSet._id)}
                                    >
                                        <i className="fa-solid fa-eye"></i>
                                    </span>
                                    </Tooltip>
                                    <Tooltip text="View Certificate" position="top">
                                    <span
                                        className="text-blue-500 cursor-pointer hover:text-blue-700 transition"
                                        onClick={() => {
                                        const certificate = examSet.certificate[0];
                                        if (certificate && certificate.certificateDate) {
                                            handleCertificateView(
                                                certificate.certificateNumber,
                                                certificate.certificateDate,
                                                certificate.certificateName,
                                                certificate.certificateTitle,
                                                certificate.certificateRemarks,
                                                certificate.certificateTemplate,
                                                certificate.signImage1,
                                                certificate.signName1,
                                                certificate.signDesig1,
                                                certificate.signEntity1,
                                                certificate.isSignatory2,
                                                certificate.signImage2,
                                                certificate.signName2,
                                                certificate.signDesig2,
                                                certificate.signEntity2,
                                                certificate.hasSponsor,
                                                certificate.sponsorName,
                                                certificate.sponsorLogo
                                            );
                                        } else {
                                            console.error("Certificate data is incomplete or undefined");
                                        }
                                        }}
                                    >
                                        <i className="fa-solid fa-certificate"></i>
                                    </span>
                                    </Tooltip>
                                </div>
                                </div>
                                {selectedExamSetId === examSet._id && (
                                <div className="bg-black border border-gray-500 text-white mt-4 p-4 rounded-lg">
                                    <h2 className="text-yellow-200 text-sm lg:text-m font-bold mb-2">
                                        {examSet.examTitle}
                                    </h2>
                                    <div className="space-y-2 text-sm lg:text-m">
                                        <p><strong>Certificate#:</strong> 
                                            <span className="text-white">{examSet.certificate[0].certificateNumber}</span>
                                        </p>
                                        <p><strong>Certificate For:</strong> {examSet.certificate[0].certificateTitle}</p>
                                        <p><strong>Exam & Certificate Date:</strong> {new Date(examSet.dateExam).toLocaleDateString()}</p>
                                        <p><strong>Is Repeated:</strong> {examSet.isRepeatExam === 1 ? 'Yes' : 'No'}</p>
                                        <p><strong>Time Limit:</strong> {convertTimeLimit(examSet.timeLimit)}</p>
                                        <p><strong>Time Taken:</strong> {convertTimeTaken(examSet.timeTaken)}</p>
                                        <p><strong>Number of Questions:</strong> {examSet.numberOfQuestions}</p>
                                        <p><strong>Correct Answers:</strong> {examSet.correctAnswers}</p>
                                        <p><strong>Full Marks:</strong> {examSet.fullMarks}</p>
                                        <p><strong>Marks Obtained:</strong> {examSet.marksObtained}</p>
                                        <p><strong>Percentage:</strong> {examSet.percentage}%</p>
                                        <p><strong>Signatory 1:</strong> {examSet.certificate[0].signName1} ({examSet.certificate[0].signDesig1})</p>
                                        <p><strong>            </strong> {examSet.certificate[0].signEntity1}</p>
                                        { examSet.certificate[0].signName2 !== "" && (
                                            <>
                                            <p><strong>Signatory 2:</strong> {examSet.certificate[0].signName2} ({examSet.certificate[0].signDesig2})</p>
                                            <p><strong>{'          '}</strong> {examSet.certificate[0].signEntity2}</p>
                                            </>
                                        )}
                                    </div>
                                </div>
                                )}
                            </div>
                            ))
                        )}
                        </div>
                    )}
                </div>

                <div className="p-4 bg-black border-2 border-gray-300 rounded-lg shadow-sm flex flex-row justify-center items-center">
                    {certificateData && (
                        <CertificateRenderer
                            certificateNumber={certificateData.certificateNumber}
                            certificateDate={certificateData.certificateDate}
                            certificateName={certificateData.certificateName}
                            certificateTitle={certificateData.certificateTitle}
                            canvasWidth={800}
                            canvasHeight={600}
                            certificateImageSrc={certificateData.certificateTemplate}
                            certificateRemarks={certificateData.certificateRemarks}
                            certificateSignImage1={certificateData.signImage1}
                            certificateSignatoryName1={certificateData.signName1}
                            certificateSignatoryDesig1={certificateData.signDesig1}
                            certificateSignatoryEntity1={certificateData.signEntity1}
                            certificateIsSignatory2={certificateData.isSignatory2}
                            certificateSignImage2={certificateData.signImage2}
                            certificateSignatoryName2={certificateData.signName2}
                            certificateSignatoryDesig2={certificateData.signDesig2}
                            certificateSignatoryEntity2={certificateData.signEntity2}
                            certificateHasSponsor={certificateData.hasSponsor}
                            certificateSponsorName={certificateData.sponsorName}
                            certificateSponsorLogo={certificateData.sponsorLogo}
                        />
                    )}
                </div>
            </div>
            <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
                <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                    <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
                    <div className="flex flex-wrap gap-4 text-sm">
                    <Link to="/about-us" className="hover:text-teal-300">About</Link>
                    <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
                    <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
                    </div>
                </div>
            </footer>  
        </div>
    );
};

export default MyCertificatesThink5Whys;
